import { Box, Paper, Typography } from "@mui/material";
import { colors } from "../../ui/colors";
import BorderColorIcon from '@mui/icons-material/BorderColor';


export const InfoSection = ({ title, children, onEdit }) => (
    <Paper
        elevation={0}
        sx={{
            p: { xs: 2, md: 3 },
            mb: 3,
            borderRadius: "12px",
            backgroundColor: "var(--fx-surface-base, #FFFFFF)",
        }}
    >
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: { xs: "flex-start", sm: "center" },
                mb: 2,
            }}
        >
            <Typography
                variant="h6"
                sx={{
                    color: colors.gray.base,
                    fontWeight: 600,
                    fontSize: { xs: "16px", md: "18px" },
                }}
            >
                {title}
            </Typography>

            {/* Boton de edit */}
            <Box
                onClick={onEdit}
                role="button"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 36,
                    height: 36,
                    borderRadius: "50%",
                    backgroundColor: colors.orange[50],
                    color: colors.orange.base,
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    "&:hover": {
                        backgroundColor: colors.orange[100],
                        transform: "scale(1.05)",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                    },
                    "&:active": {
                        transform: "scale(0.95)",
                    },
                }}
            >
                <BorderColorIcon fontSize="small" />
            </Box>
        </Box>

        {children}
    </Paper>
);

export const InfoItem = ({ label, value }) => (
    <Box sx={{ mb: 2 }}>
        <Typography
            variant="body2"
            sx={{
                color: colors.gray[500],
                fontWeight: 500,
                fontSize: { xs: "13px", md: "14px" },
                mb: 0.5,
            }}
        >
            {label}
        </Typography>
        <Typography
            variant="body1"
            sx={{
                color: colors.gray.base,
                fontWeight: 400,
                fontSize: { xs: "14px", md: "16px" },
                backgroundColor: colors.gray[50],
                padding: "8px 12px",
                borderRadius: "8px",
                border: `1px solid ${colors.gray[200]}`,
            }}
        >
            {value || "Not provided"}
        </Typography>
    </Box>
);
